
const Parameters = ()=>{
    // Obtener la URL actual
    const currentURL = window.location.href;
    // Crear un nuevo objeto URLSearchParams utilizando la URL actual
    const searchParams = new URLSearchParams(currentURL);
    // Iterar sobre los parámetros y obtener sus nombres y valores
    searchParams.forEach(function(value) {
        localStorage.setItem('categorie', value);
    });
}

export { Parameters }